import { Box } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

const SabalOrganizationUnderwritingSettingsDeleted = ({ event }: { event: any }) => {
  const deleted = event.data?.deletedUnderwritingSettings;
  const stateLabel = deleted?.state ? `, ${deleted.state}` : '';
  const programTypeLabel = event.data?.programType ? ` (${event.data.programType}${stateLabel})` : '';

  return (
    <Box display="block">
      <EventBy event={event} /> deleted underwriting settings{programTypeLabel}
    </Box>
  );
};

export default SabalOrganizationUnderwritingSettingsDeleted;
